import { ShrtflConfig } from 'finviz-charts/app/indicators/configs/shrtfl'
import { ShrtraConfig } from 'finviz-charts/app/indicators/configs/shrtra'
import { Position } from 'finviz-charts/types/shared'

import { QuoteRoutes } from '../../main/constants'
import { Utils, convertTa } from '../charts-lib'
import { decodeQueryString } from '../queryString'

export function getInitChartConfig() {
  const { ty } = decodeQueryString<{ ty?: string }>()
  window.globalChartConfig.scrollable = false
  if (FinvizSettings.hasUserPremium) {
    window.globalChartConfig.scrollable = window.globalChartConfig.editable || !Utils.isMobile()
  }

  if (FinvizSettings.TA) {
    let finvizSettingsTa = FinvizSettings.TA
    const COTs = FinvizSettings.COTs
    if (ty === QuoteRoutes.ShortInterest) {
      finvizSettingsTa = {
        ...finvizSettingsTa,
        overlays: [],
        indicators: [
          {
            name: ShrtflConfig.abbreviation,
            parameters: '',
            position: Position.Below,
          },
          {
            name: ShrtraConfig.abbreviation,
            parameters: '',
            position: Position.Below,
          },
        ],
      }
    }
    convertTa.mergeChartAndTAConfig(window.globalChartConfig, finvizSettingsTa, COTs ? { COTs } : undefined)
  }

  return window.globalChartConfig
}
